import { Link } from "react-router-dom";
import { siteConfig } from "../lib/siteConfig";

const socialLinks = [
  { label: "Telegram", href: "https://t.me/Feaslots", icon: "/assets/social/telegram.svg" },
  { label: "Facebook", href: "https://www.facebook.com/feaslot", icon: "/assets/social/facebook.svg" },
  { label: "Instagram", href: "https://www.instagram.com/fea.slots", icon: "/assets/social/instagram.svg" },
  { label: "TikTok", href: "https://www.tiktok.com/@feaslots", icon: "/assets/social/tiktok.svg" },
];

export default function Footer({ theme = "light" }) {
  const isLight = theme === "light";
  const footerClass = isLight
    ? "mt-24 border-t border-slate-200 bg-white text-slate-950"
    : "mt-24 border-t border-white/5 bg-[#05070D]";
  const mutedClass = isLight ? "text-slate-500" : "text-white/50";
  const listClass = isLight ? "space-y-2 text-slate-600" : "space-y-2 text-white/60";
  const linkHoverClass = isLight ? "hover:text-slate-950" : "hover:text-white";
  const bottomClass = isLight
    ? "max-w-7xl mx-auto px-6 md:px-10 py-6 border-t border-slate-200 flex flex-col md:flex-row justify-between text-xs text-slate-500 gap-2"
    : "max-w-7xl mx-auto px-6 md:px-10 py-6 border-t border-white/5 flex flex-col md:flex-row justify-between text-xs text-white/40 gap-2";

  return (
    <footer className={footerClass}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={siteConfig.logoUrl} alt={siteConfig.name} className="w-10 h-10 rounded-full object-cover ring-1 ring-[#2F6FA5]/60" />
            <span className="font-display text-xl">{siteConfig.name}</span>
          </div>
          <p className={mutedClass}>Free to play social casino fun. Real rewards through sweepstakes.</p>
          <div className="mt-5 flex flex-wrap gap-3" aria-label={`${siteConfig.name} social links`}>
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open ${siteConfig.name} on ${link.label}`}
                title={link.label}
                className="grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br from-[#FFE892] to-[#F2B84B] shadow-lg shadow-[#F2B84B]/20 ring-1 ring-white/30 transition-all hover:-translate-y-0.5 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2F6FA5] focus-visible:ring-offset-2"
              >
                <img src={link.icon} alt="" className="h-5 w-5 object-contain" loading="lazy" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#2F6FA5] mb-3">Play</h4>
          <ul className={listClass}>
            <li><Link to="/games" className={linkHoverClass}>Slots</Link></li>
            <li><Link to="/leaderboard" className={linkHoverClass}>Leaderboard</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#2F6FA5] mb-3">Company</h4>
          <ul className={listClass}>
            <li><Link to="/about" className={linkHoverClass}>About</Link></li>
            <li><Link to="/reviews" className={linkHoverClass}>Player reviews</Link></li>
            <li><Link to="/press" className={linkHoverClass}>Press</Link></li>
            <li><Link to="/careers" className={linkHoverClass}>Careers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#2F6FA5] mb-3">Legal</h4>
          <ul className={listClass}>
            <li><Link to="/terms" className={linkHoverClass}>Terms</Link></li>
            <li><Link to="/privacy" className={linkHoverClass}>Privacy</Link></li>
            <li><Link to="/responsible-play" className={linkHoverClass}>Responsible Play</Link></li>
          </ul>
        </div>
      </div>
      <div className={bottomClass}>
        <span>(c) 2026 {siteConfig.name}. 18+ only - Play responsibly.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#2F6FA5]">Operator console -></Link>
      </div>
    </footer>
  );
}
